import { logError } from "~/utils/logging";

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.config.errorHandler = (error, instance, info) => {
        // Capture any unhandled Vue error and report it to New Relic via the
        // logging facade, which safely no-ops if the agent has not loaded yet.
        logError("Unhandled Vue error (" + info + ")", error);
    };
});
